module.exports = __webpack_public_path__ + "static/images/hero.a505eaa7b0ba988ef900ad1621811aa4.jpg";